(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/NodeHeaderView',["jquery", "backbone", "hbs!pricelist/templates/node-header", "hbs!pricelist/templates/node-header-format"], function($, Backbone, nodeHeaderTemplate, nodeHeaderFormatTemplate) {
    var View, isPrint;
    isPrint = $("#container").data("mediagroup") === "print";
    return View = (function(superClass) {
      extend(View, superClass);

      function View() {
        this.render = bind(this.render, this);
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.tagName = "div";

      View.prototype.className = "node-header";

      View.prototype.initialize = function() {
        this.headerLayout = (function(_this) {
          return function() {
            var array, head, i, j, len, len1, name, price, ref, visiblePrices;
            array = [];
            visiblePrices = _this.options.headerLayout.visiblePrices;
            ref = _this.options.headerLayout.content;
            for (i = 0, len = ref.length; i < len; i++) {
              head = ref[i];
              switch (head) {
                case "s":
                  array.push({
                    name: "Avdelning",
                    "class": "node-head section"
                  });
                  break;
                case "p":
                  array.push({
                    name: "Position",
                    "class": "node-head position"
                  });
                  break;
                case "f":
                  array.push({
                    name: "Format",
                    "class": "node-head format",
                    isFormat: true,
                    isPrint: isPrint
                  });
                  break;
                case "v":
                  array.push({
                    name: "Prisvariant",
                    "class": "node-head variant"
                  });
                  break;
                case "i":
                  array.push({
                    name: "Införandedagar",
                    "class": "node-head weekday"
                  });
                  break;
                case "c":
                  name = isPrint ? "Kommentar" : "Andel";
                  array.push({
                    name: name,
                    "class": "node-head comment"
                  });
                  break;
                case "r":
                  if (visiblePrices.length === 1 && visiblePrices[0] === "4") {
                    array.push({
                      name: "Pris",
                      "class": "node-head price color-4"
                    });
                  } else {
                    for (j = 0, len1 = visiblePrices.length; j < len1; j++) {
                      price = visiblePrices[j];
                      array.push({
                        name: _this.priceName(price),
                        "class": "node-head price color-" + price
                      });
                    }
                  }
                  break;
                default:
                  null;
              }
            }
            return array;
          };
        })(this)();
        return this.template = nodeHeaderTemplate;
      };

      View.prototype.render = function() {
        this.$el.html(this.template({
          head: this.headerLayout
        }));
        return this;
      };

      View.prototype.priceName = function(code) {
        switch (code) {
          case "1":
            return "S/V";
          case "2":
            return "S/V +1";
          case "3":
            return "S/V +2";
          case "4":
            if (isPrint) {
              return "Färg";
            } else {
              return "Pris";
            }
            break;
          default:
            return null;
        }
      };

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=NodeHeaderView.js.map
;
